/**
 * @file Handle view-album redirect requests.
 */

import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import qs from 'query-string';

import { MeWithAlbumMembershipsBasic } from '../../graphql/queries/account';
import { getAlbumMembershipById } from '../../util/account';
import { sentryCaptureMessage } from '../../util/sentry';

class ViewAlbumRedirect extends Component {
  static propTypes = {
    albumMembership: PropTypes.shape({
      album: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
    accountId: PropTypes.string,
    loading: PropTypes.bool,
  };

  render() {
    const { albumMembership, loading, accountId } = this.props;

    if (loading) {
      return null;
    }

    if (!albumMembership) {
      sentryCaptureMessage('View Album Redirect :: Invalid album membership', {
        level: 'error',
        extra: {
          accountId,
        },
      });

      const redirectToError = {
        pathname: '/error',
        state: {
          error: 'Link is no longer valid',
        },
      };

      return <Redirect to={redirectToError} />;
    }

    return (
      <Redirect
        to={`/app/shutterbug/hierarchy-items/${albumMembership.album.id}/matches`}
      />
    );
  }
}

export { ViewAlbumRedirect };

const withUserAlbumMemberships = graphql(MeWithAlbumMembershipsBasic, {
  options: () => ({
    ssr: false,
  }),
  props: ({ data: { me, loading }, ownProps: { location } }) => ({
    albumMembership: getAlbumMembershipById(
      me,
      qs.parse(location.search).albumMembership || '',
    ),
    accountId: me && me.id,
    loading,
  }),
});

export default compose(withRouter, withUserAlbumMemberships)(ViewAlbumRedirect);
